<template>
  <div :class="containerClasses" @click="toggleChecked" @keypress.space="toggleChecked">
    <span v-bind="containerAttributes"  :class="checkClass">
        <i class="icon-check"></i>
    </span>
    <div :id="checkboxId">
        <slot/>
    </div>
  </div>
</template>

<script>
import idMixin from '@/mixins/aha-id';
import { KeyCodes } from 'bootstrap-vue/src/utils';
export default {
    mixins: [idMixin],
    data: function() {
        return {
            isChecked: false,
            checkboxId: null
        };
    },
    props: {
        checkClass: {
            type: String
        }
    },
    computed: {
        containerClasses() {
            return [this.isChecked ? 'is-checked' : '', this.class];
        },
        containerAttributes() {
            return {
                'role': 'checkbox',
                'aria-checked': this.isChecked.toString(),
                'tabindex': 0,
                'aria-labelledby': this.checkboxId
            };
        }
    },
    mounted() {
        this.checkboxId = this.safeId('_PHD_checkbox_');
        // on hidden
        this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
            if(bvEvent.vueTarget.$options.propsData.id === this.$parent.$options.propsData.id){
                this.isChecked = false
                let elm = this.$parent.$el.querySelector('.checked-continue')
                this.resetClass(elm, 'disabled')
                // toggleClass(this.$parent.$el.querySelector('.ec-continue'))
            }
        })
        
    },
    methods: {
        toggleChecked(evt) {
            if(evt.type === 'click' || evt.keyCode === KeyCodes.SPACE) {
                evt.preventDefault();
                this.isChecked = !this.isChecked;
                let elm = this.$parent.$el.querySelector('.checked-continue')
                console.log('element ', elm)
                this.toggleClass(elm, 'disabled')
            }
        },
        toggleClass(elm, classname) {
            console.log('toggle', elm, classname)
            elm.classList.toggle(classname)
        },
        resetClass(elm, classname) {
           if(!elm.classList.contains(classname)) {
                    elm.classList.add(classname)
                } 
        }
        
        
    }
}
</script>



// WEBPACK FOOTER //
// src/app/components/phd/phd-display-checkbox.vue